export const headerProduct = [
  "ID Prodotto",
  "Prodotto",
  "N",
  "P2O5",
  "K2O",
  "CaO",
  "MgO",
  "SO3",
  "€/kg",
];

export const productRowsDefault = [
  {
    productId: "00001",
    product: "STALLATICO",
    countN: 2,
    countP2O5: 2,
    countK2O: 2,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 0.2],
      ["00002", 0.2],
    ],
  },
  {
    productId: "00002",
    product: "NITROPHOSKA BLU",
    countN: 12,
    countP2O5: 12,
    countK2O: 17,
    countCaO: 0,
    countMgO: 2,
    countSO3: 20,
    countEurokg: [
      ["00001", 0.18],
      //["00002", 0.2],
    ],
  },
  {
    productId: "00003",
    product: "GENERICO",
    countN: 10,
    countP2O5: 5,
    countK2O: 15,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 0.18],
      //["00002", 0.18],
    ],
  },
];
